/**
 * 过滤已经达到最大购买数量的商品
 */
const filterMaxPurchasedProducts = (products = [], purchasedList = []) => {
  if (!purchasedList || !purchasedList?.length) return products;

  if (!products || !products?.length) return [];
  const afterFilterProducts = products.reduce((pre, cur) => {
    const purchasedProductCount =
      (
        (purchasedList || [])?.find(item => {
          return (+cur?.id || +cur?.product_id) === +item?.product_id && cur?.is_pantry === item?.is_pantry;
        }) || {}
      )?.sum_quantity || 0;

    let maxCanBuyQuantity =
      cur?.is_limit_product && +cur?.price
        ? +cur?.max_order_quantity - purchasedProductCount
        : +cur?.max_order_quantity;

    maxCanBuyQuantity = cur?.remaining_count < maxCanBuyQuantity ? cur?.remaining_count : maxCanBuyQuantity;

    if (maxCanBuyQuantity >= cur.min_order_quantity) {
      pre?.push(cur);
    }
    return pre;
  }, []);
  return afterFilterProducts;
};

/**
 * 判断是否是限购商品且购买已达限量
 */
const isMaxLimitPurchased = (product, purchasedList = []) => {
  if (!product || !purchasedList || !purchasedList?.length || !product?.is_limit_product || !product?.price)
    return false;
  const purchasedProductCount =
    (purchasedList || [])?.find(item => {
      return (+product?.id || +product?.product_id) === +item?.product_id && product?.is_pantry === item?.is_pantry;
    })?.sum_quantity || 0;

  let maxCanBuyQuantity = +product?.max_order_quantity - purchasedProductCount;

  maxCanBuyQuantity = product?.remaining_count < maxCanBuyQuantity ? product?.remaining_count : maxCanBuyQuantity;

  if (maxCanBuyQuantity < product?.min_order_quantity) return true;
  return false;
};

/**
 * 获取产品卡片额外属性
 * @param extra_attrs 额外属性
 * @returns 额外属性
 */
export const getProductCardExtraAttrs = (data: ProductType): Record<string, unknown> | undefined => {
  const { extra_attrs } = data ?? {};
  if (!extra_attrs) return {};
  if (typeof extra_attrs === 'object') return extra_attrs;
  try {
    return JSON.parse(extra_attrs) as Record<string, unknown>;
  } catch {
    return {};
  }
};

/**
 * 获取图片地址
 * 最新改动：接口新返回media字段，包含媒体类型、图片/视频地址等信息
 * 这里兼容下新旧数据
 * @param data 商品数据
 */
const getImgUrl = (data: ProductType) => {
  if (!data) return '';
  if (data && 'media' in data && data.media?.url) {
    return data.media.url;
  }
  return data?.square_img_url || data?.img || data?.image_url;
};

export { filterMaxPurchasedProducts, isMaxLimitPurchased, getImgUrl };
